// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"1e992ba4","95":"2df72464","199":"fbb31bfa","206":"b763a9b5","377":"5c1f8e35","414":"3729038a","455":"692cea79","570":"46a32a2d","600":"6b01f887","605":"d7929f24","622":"20fa3da9","661":"06fd6f6b","731":"ace29fcd","977":"39f7c31e","981":"4eb05259"}[chunkId] + ".chunk.js";
};